import m from "../../geodata/es2015/franceHigh";
window.am4geodata_franceHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/franceHigh.js
// module id = null
// module chunks = 